export default __webpack_public_path__ + "static/media/1845.7010eabf.png";